import { render, staticRenderFns } from "./pricing-detail.vue?vue&type=template&id=edeaf21c&"
import script from "./pricing-detail.vue?vue&type=script&lang=js&"
export * from "./pricing-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edeaf21c')) {
      api.createRecord('edeaf21c', component.options)
    } else {
      api.reload('edeaf21c', component.options)
    }
    module.hot.accept("./pricing-detail.vue?vue&type=template&id=edeaf21c&", function () {
      api.rerender('edeaf21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/pricing-detail.vue"
export default component.exports